import * as React from 'react'
import { SegControl, Box, Text, Row } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

export enum ButtonValue {
  ADD_ITEM = 'addItem',
  SKIP_ADD_ITEM = 'skipAddItem',
}
interface Props {
  selectedButton: string
  handleSegChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const ItemSegmentedControl: React.FC<Props> = ({
  selectedButton,
  handleSegChange,
}) => {
  const t = useT()
  const segControlCopies = {
    addItem: t('Add an item', {
      _context:
        'Text in  segment control for service item step in service modal.',
    }),
    noItem: t('There is no item', {
      _context:
        'Text in segment control for service item step in service modal.',
    }),
  }

  return (
    <Row>
      <SegControl
        className="service-modal-seg-control"
        name={ButtonValue.ADD_ITEM}
        checked={selectedButton === ButtonValue.ADD_ITEM}
        value={ButtonValue.ADD_ITEM}
        stretched
        onChange={handleSegChange}
        data-track="add-service-item"
      >
        <Box className="vd-pl6 vd-pr6 vd-pt3 vd-pb3">
          <Text tag="div" type="intro" style={{ fontWeight: 'bold' }}>
            {segControlCopies.addItem}
          </Text>
        </Box>
      </SegControl>
      <SegControl
        className="service-modal-seg-control"
        name={ButtonValue.SKIP_ADD_ITEM}
        checked={selectedButton === ButtonValue.SKIP_ADD_ITEM}
        value={ButtonValue.SKIP_ADD_ITEM}
        stretched
        onChange={handleSegChange}
        data-track="skip-add-service-item"
      >
        <Box className="vd-pl6 vd-pr6 vd-pt3 vd-pb3">
          <Text tag="div" type="intro" style={{ fontWeight: 'bold' }}>
            {segControlCopies.noItem}
          </Text>
        </Box>
      </SegControl>
    </Row>
  )
}
